import type { RouteRecordRaw } from 'vue-router';

export default {
  path: '/access-restricted',
  name: 'access-restricted',
  component: () => import('@/views/dashboard/access-restricted/access-restricted.vue'),
} satisfies RouteRecordRaw;
